import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type { BatteryProposalFinancialSummaryResponseDto } from "../dto/battery-proposal.dto"
import { batteryProposalService } from "../services/battery-proposal.service"

export default function useBatteryProposalFinancialSummary(
  proposalId: string | undefined,
  { enabled = true }: { enabled?: boolean } = {},
): UseQueryResult<BatteryProposalFinancialSummaryResponseDto> {
  return useQuery({
    queryKey: queryKeys.batteryProposal.financialSummary(proposalId ?? ``),
    queryFn: () => {
      if (!proposalId) {
        throw new Error(`Battery-Only Proposal id is required`)
      }

      return batteryProposalService.getFinancialSummary(proposalId)
    },
    enabled: Boolean(proposalId) && enabled,
    retry: 1,
    refetchOnWindowFocus: false,
  })
}
